import type { ImportedShape } from './mapImport'

/** The server's shape for an imported one; the same mapping as the app's `saveRequestFor`. */
export function featureRequestFor(
  shape: ImportedShape,
  visibility: 'MISSION' | 'FACTION' | 'TEAM',
  clientRequestId: string,
): Record<string, unknown> {
  const remarks = [shape.folder, shape.description].filter(Boolean).join('\n')
  return {
    geometryType: { point: 'POINT', line: 'POLYLINE', area: 'POLYGON', circle: 'CIRCLE' }[shape.kind],
    positions: shape.points.map((p) => ({ latitude: p.latitude, longitude: p.longitude })),
    radiusMetres: shape.radiusMetres,
    visibility,
    affiliation:
      shape.affiliation === 'hostile'
        ? 'HOSTILE'
        : shape.affiliation === 'neutral'
          ? 'NEUTRAL'
          : shape.affiliation === 'unknown'
            ? 'UNKNOWN'
            : 'FRIEND',
    label: shape.name,
    remarks: remarks ? remarks.slice(0, 2000) : undefined,
    colorHex: shape.colorHex,
    strokeWidth:
      shape.strokeWidth === undefined ? undefined : Math.min(12, Math.max(1, Math.round(shape.strokeWidth))),
    fillOpacity: shape.fillOpacity === undefined ? undefined : Math.min(1, Math.max(0, shape.fillOpacity)),
    clientRequestId,
  }
}

/** "Operazione Città" becomes `operazione-citt`, the same rule the server and the app use. */
export function kmlFileNameFor(missionName: string): string {
  const slug = missionName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return slug || 'tacmaps-map'
}
